import api, { apiWithToken } from './api';
import { decodeData } from '../helpers/function_helper';
import { API_ENDPOINTS } from '../config/apiUrls';

export const timChuyen = async (searchData) => {
  try {
    const response = await apiWithToken.post(API_ENDPOINTS.FLIGHT_SEARCH, searchData);
    return decodeData(response.data);
  } catch (error) {
    throw error;
  }
};

export const timKiemSanBay = async (searchText) => {
  try {
    const response = await apiWithToken.post(API_ENDPOINTS.AIRPORT_SEARCH, { tim_kiem: searchText });
    return decodeData(response.data);
  } catch (error) {
    throw error;
  }
};

export const layDanhSachSanBay = async () => {
  try {
    const response = await apiWithToken.get(API_ENDPOINTS.AIRPORT_LIST);
    return decodeData(response.data);
  } catch (error) {
    throw error;
  }
};

export const layDanhSachPhuTro = async (requestData) => {
  try {
    const response = await apiWithToken.post(API_ENDPOINTS.SUPPORT_SERVICES, requestData);
    return decodeData(response.data);
  } catch (error) {
    throw error;
  }
};

export const layDanhSachQuocGia = async () => {
  try {
    const response = await apiWithToken.get(API_ENDPOINTS.COUNTRIES);
    return decodeData(response.data);
  } catch (error) {
    throw error;
  }
};

export const tinhPhiVe = async (requestData) => {
  try {
    const response = await apiWithToken.post(API_ENDPOINTS.CALCULATE_FARE, requestData);
    return decodeData(response.data);
  } catch (error) {
    throw error;
  }
};

export const datChuyen = async (bookingData) => {
  try {
    const response = await apiWithToken.post(API_ENDPOINTS.BOOK_FLIGHT, bookingData);
    return decodeData(response.data);
  } catch (error) {
    throw error;
  }
};
